import React, {FC} from 'react';

import {ReferralUser as ReferralUserModel} from '../../../../api-client';
import {Block} from '../../../layout';
import ReferralUser from '../ReferralUser';
import styles from './ReferralUserList.module.scss';

interface Props {
  users: ReferralUserModel[];
}

const emptyUser: ReferralUserModel = {
  uuid: '',
  name: '',
  phone: '',
  registerDate: undefined,
  userType: '',
  transactions: [],
  totalUserAccrued: undefined,
};

const ReferralUserList: FC<Props> = ({users}) => {
  const displayUsers = users.length > 0 ? users : [emptyUser];

  return (
    <div className={styles.referralUserList}>
      <Block>
        <Block.Content>
          <Block.Header withPadding>
            <div className={styles.referralUserList__heading}>
              Список приглашенных инвесторов
            </div>
          </Block.Header>
          <Block.Body withPadding={false} className={styles.referralUserList__body}>
            <ul className={styles.referralUserList__items}>
              {displayUsers.map((user, idx) => (
                <ReferralUser user={user} key={idx} />
              ))}
            </ul>
          </Block.Body>
        </Block.Content>
      </Block>
    </div>
  );
};

export default ReferralUserList;
